<h1 mat-dialog-title>
    Upload Files
</h1>

<!--<h2 mat-dialog-title>Upload Files</h2>-->

<mat-dialog-content [formGroup]="form">
    <label for="filesToUpload">Choose File(s)</label>

    <input type="file" id="filesToUpload" multiple formControlName="filesToUpload"
           (change)="handleFileInput($event)">
    <br/>
    <mat-form-field>
        <label for="fileDirectory">File Directory</label>
            <input matInput id="fileDirectory"
                   placeholder="{{fileDirectory}}"
                   formControlName="fileDirectory">
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" (click)="onDismiss()">Cancel</button>
    <button class="mat-raised-button mat-primary" (click)="processUploads()">Upload</button>
</mat-dialog-actions>


